<template>
   <div id="profile-pic-demo" class="bg-light pt-3">
    <VueFileAgent
       ref="profile"
       class="profile-pic-upload-block"
      :multiple="false"
      :deletable="false"
      :meta="false"
      :compact="true"
      :accept="'image/*'"
      :maxSize="'400MB'"
      :maxFiles="1"
      :helpText="selectText"
      :errorText="{
        type: errorMessage,
        size: errorSize,
       }"
       v-model="fileRecords"
       @select="filesSelected($event)"
    >

    <template v-slot:after-inner>
        <!-- <span title="after-inner" class="">프로필 이미지를 넣어 주세요.</span> -->

        <div>
            <button type="button" class="btn"  v-show="fileRecords" @click="removePic()">삭제</button>
        </div>
     </template>

    </VueFileAgent>
  </div>
</template>
<script>
import Axios from 'axios'

  export default {
    // ...
    data: function(){
      return {
          fileRecords: null
        , detail : {}
        , uploaded : false
        , selectText :  "프로필 이미지를 넣어 주세요."
        , errorMessage : "이 형식은 이미지형식이 아닙니다."
        , errorSize : "사이즈가 400MB가 넘습니다."
        , cnt : 0
        , code : 'PROFILE'
      };
    },
    props:['listimgfile'],
    mounted:function(){

    }
    , methods:{
          filesSelected(evt){
                let vm = this;
               if(evt[0].file.type.indexOf('image') > -1){
                 // vm.cnt++;
                 // vm.getUploadFiles(evt, vm.cnt);
                 vm.getUploadFiles(evt, vm.cnt + 1);
               }else{
                   return false;
               }
          }
        , removePic(){
             let vm = this;
             if(confirm("삭제하시겠습니까")){
                vm.uploaded = false;

                let _inner = $("#fileKey").val();
                let _param = {paramUid : _inner, defaultView: 'PROFILE'};

                Axios.post("/api/profile/delete", _param, {
                }).then(function(response) {
                            vm.cnt--;
                          vm.$refs.profile.deleteFileRecord(vm.fileRecords);
                          vm.$refs.profile.removeFileRecord(vm.fileRecords);
                }).catch(function(ex) {
                    console.log(ex);
                });

             }
        }
        , setFileRemindFromFile(_data){
          return  {
              name : _data.file.name,
              sizeText :_data.sizeText,
              size : _data.size,
              type : _data.type,
              ext : _data.ext,
              width : _data.dimensions.width,
              height : _data.dimensions.height,
              color : _data.color
           };
        }
        , setFileRemindFromDB(_data){
           return  {
              name : _data.file_org_name,
              sizeText :_data.sizeText,
              size : _data.size,
              type : _data.filetype,
              ext : _data.fileExt,
              filePath: '/img/' + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
              url: "/img/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
              //urlResized: _data.imgBase64,
              lastModified: 1583992794341
           };
        }
        , getUploadFiles(evt, cnt){
             let vm = this;
             let _inner = $("#fileKey").val();
             let _key = $("#fileKey").val();
             let _sprt = $("#fileSprt").val();
             let _form = new FormData();
             let _data = vm.setFileRemindFromFile(evt[0]);
             let _param = _data;

             _form.append('uploadFiles', evt[0].file);
             _form.append('paramText', (_sprt == undefined || _sprt == null) ? 'PROFILE' : _sprt);
             _form.append('resultData', cnt);
             _form.append('defaultView', _inner);
             _form.append('paramOption', JSON.stringify(_param) );

              Axios.post("/api/profile/upload", _form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function(response) {
                if (response.data.file_path != null && response.data.file_path !== '') {
                  vm.cnt++; // 업로드 성공 시, 증가
                }

              }).catch(function(ex) {
                 console.log(ex);
              });
        }
    }
  }
</script>
